<template>
	<div class="">
		<!-- :on-preview="handlePictureCardPreview" -->
		<el-upload
    :on-progress = 'onProgressTest'
		  :action="imgAddress"
		  :file-list="fromImgList"
		  list-type="picture-card"
		  :on-success="handleAuthSuccess"
		  :on-remove="handleRemove"
		  :before-upload="beforeAvatarUpload"
		  :headers="headers"
		  :limit="imgMaxLength">
		  <i class="el-icon-plus"></i>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
		  <img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script type="ecmascript-6">
	import {getCookie} from '../../../static/js/cookie.js'
	export default{
		props:{
			fromImgList:{
				type: Array,
		    default: function () {
	        return []
		    }
			},
			ruleImgList:{
				type: Array,
		    default: function () {
	        return []
		    }
			},
			imgMaxLength:{
				default:5,
			},
			maxSize:{
				default:1
			},
			toggleClass:{
				required:true
			},
			fileType:{
				type: Array,
		    default: function () {
	        return []
		    }
			}
		},
		data() {
			return {
				headers:{//上传图片头信息
    			// "Authorization": JSON.parse(getCookie('userMass')).tokenType+ ' ' + JSON.parse(getCookie('userMass')).accessToken
    		},
				imgAddress:Action.UNLOGINSEACHER_UPLOADIMG,//上传图片接口
				dialogImageUrl: '',//大图图片地址
        dialogVisible: false,//大图弹框的显隐
        count:0
			}
		},
		watch:{
			fromImgList(val) {
				this.count++;
				if(this.count==1) {
					val.forEach((item) => {
						this.ruleImgList.push({
							"url":item.url.replace(commonUrl,''),
						});
	      	});
	    	}
			}
		},
		methods:{
      onProgressTest(event, file, fileList){
        let index = 0
        // 只有fileList 跟file 里面的uid是唯一的互相对应的
        fileList.forEach((v, i) => {
          if (v.uid === file.uid) {
            index = i
          }
        })
        // 获取动态的进度
        let percent = parseInt(event.percent)
        this.$nextTick(() => {
          setTimeout(() => {
            if (percent >= 99) {
            // 当动态的进度超过99就获取dom 让值一直显示99直到上传成功
              let dom = document.getElementsByClassName('el-upload-list__item')[index]
              let progressText = dom.getElementsByClassName('el-progress__text')
              if (progressText && progressText.length) {
                progressText[0].style.opacity = 0
                progressText[0].innerText = '99%'
                progressText[0].style.opacity = 1
                $(this.toggleClass).find('.el-upload').hide();
              }
            }
          })
        })
      },
			handlePictureCardPreview(file) {
        if(file.response) {
					this.dialogImageUrl = commonUrl + file.response.result.filesMap.file[0].path;
				} else {
					this.dialogImageUrl = file.url;
				}
        this.dialogVisible = true;
      },
      beforeAvatarUpload(file) {//图片上传之前的操作
        let isJPG = false;
        if(this.fileType.length>0) {
        	 this.fileType.forEach((item) => {
        	 	if(file.type == item) {
        	 		isJPG = true;
        	 	}
        	 })
        } else {
        	isJPG = (file.type == 'image/jpeg' || file.type == 'image/JPEG' || file.type == 'image/jpg' || file.type == 'image/JPG' || file.type == 'image/png' || file.type == 'image/PNG');
        }
        const isLt2M = file.size / 1024  < (this.maxSize*1024);
        if (!isJPG) {
          this.$message.error('上传图片格式有误!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 '+ this.maxSize + 'M!');
        }
        return isJPG && isLt2M;
      },
      handleAuthSuccess(res,file,fileList) {//图片上传成功之后的操作
      	this.ruleImgList.push({
      		"url":res.result.filesMap.file[0].path,
      	});
      	if(fileList.length>(this.imgMaxLength-1)) {
      		$(this.toggleClass).find('.el-upload').hide();
      	}else{
          $(this.toggleClass).find('.el-upload').show();
        }
      },
      handleRemove(file,fileList) {
      	if(file.response) {
      		this.ruleImgList.forEach((item,index) => {
	      		if(file.response.result.filesMap.file[0].path==item.url) {
	      			this.ruleImgList.splice(index,1);
	      		}
	      	});
      	} else {
      		this.ruleImgList.forEach((item,index) => {
	      		if(file.url ==  commonUrl+item.url) {
	      			this.ruleImgList.splice(index,1);
	      		}
	      	});
      	};
      	if(fileList.length<this.imgMaxLength) {
      		$(this.toggleClass).find('.el-upload').show();
      	}
      },
		},
		mounted() {
			this.$nextTick(() => {
				// this.imgAddress = Action.UPLOAD_IMG;
				// console.log('------------------',Action.UPLOAD_IMG)
				// console.log('------------------',this.ruleImgList)
			})
		}
	}

</script>

<style lang="less" rel="stylesheet" scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/imgUpload1/index.vue